// 2018 Topps Star Wars Galactic Files — authored by hand (2026-09-18,
// collector-requested; completes the Galactic Files pair)
// =============================================================================
// SOURCES: the official Topps marketing checklist PDF (GTS, gogts.net —
// pre-release, so it OMITS the second hundred base cards and the patch set),
// nslists (House of Checklists, post-release and code-complete), and TCDB
// (sid 170092 + per-tier sids, which carry the printed card codes and SN
// tags). TCDB's full 200-card base list matches nslists row for row.
//
// ⚠️ BASE NUMBERING CONTINUES FROM 2017 GALACTIC FILES REBORN: every film
// section picks up where the 2017 file stopped (TPM-26.., AOTC-21.., ACW-22..,
// ROTS-19.., REB-16.., ANH-30.., ESB-17.., ROTJ-19.., RO-9.., TFA-31..) and
// The Last Jedi joins as TLJ-1..20. A low-numbered card (TPM-1..25 etc.)
// belongs in `2017-galactic-files-reborn.js`, never here — the ONLY exception
// is the 2017 BASE IMAGE VARIATIONS chase below, 25 short prints that REUSE
// 2017 card numbers with new photos (their print codes end in 826; that's how
// collectors tell them from real 2017 cards). Base ladder: Orange and Blue
// (1:2) unnumbered, Green /199, Purple /99, Gold /10, White /5, Red 1/1.
// Plates exist for base, inserts and autos; CK does not track plates.
//
// INSERTS: seven sets sharing the Purple /99 / Gold /10 / White /5 ladder
// (TCDB SN tags; inserts have NO Red tier in this year). nslists documents a
// "no foil logo" variation on the Vehicles insert — single-source, so it is
// NOT modeled; add it only with a specimen.
//
// AUTOGRAPHS: 44 signers (official PDF roster). Uniform CK ladder Green /50,
// Purple /25, Gold /10, White /5, Red 1/1 — but per-signer availability
// varies hugely: only 16 signers have the numbered Brown base (per-signer
// runs /99../440, TCDB SN tags; CK cannot model per-card runs, so base rows
// are serial-less), Ian McDiarmid exists ONLY as the Red 1/1 (A-IM), and the
// five marquee signers Anthony Daniels, Carrie Fisher, Felicity Jones,
// Harrison Ford and Sarah Michelle Gellar are announced in the official PDF
// but no tier of theirs is documented ANYWHERE (nslists shows Daniels as
// plates-only) — included for completeness with CK-ASSIGNED codes (A-ADA,
// A-CF, A-FJ, A-HF, A-SMG), flagged because no source prints theirs.
//
// DUAL AUTOGRAPHS (9): NO base tier exists — the cards live only as Purple
// /25, Gold /10, White /5, and availability varies per card (e.g. DA-RB
// Ridley/Boyega is White /5 only). Codes DA-JW, DA-FF, DA-TL are CK-assigned
// (undocumented in every source; initials pattern, same caveat as above —
// note DA-TL also exists as a printed code in the 2017 file for a different
// card; separate sets, no key collision). Taylor/Lanter characters are their
// Clone Wars roles (Obi-Wan Kenobi / Anakin Skywalker), not source-stated.
// TRIPLES (2): Gold /10 + White /5; TA-WQM is CK-assigned. SIX-PERSON (1):
// the Rogue One cast; TODO (rule 7) — no source documents its print run, so
// it carries no serial slot until a specimen shows one; SPA-1 is CK-internal.
//
// SOURCE MATERIAL FABRIC SWATCHES (8): the base IS serial-numbered /50
// (TCDB SN50) → rule-6 blank slot, plus Purple /25, Gold /10, White /5,
// Red 1/1. Two cards exist only at Purple /25 (CR-C Caretaker and the
// Praetorian Guard, whose CR-PG code is CK-assigned) — their /50 slot will
// simply go unused.
//
// MANUFACTURED MOVIE POSTER PATCH (56): value-box hit, Gray base unnumbered,
// Blue /99, Green /50, Purple /25, Gold /10, White /5, Red 1/1. MA- codes
// from nslists (complete); TCDB agrees on the 56-card roster. The `artist`
// field carries the poster's film, which is what tells the four Han Solos
// apart. Per-card tier availability varies here too (nslists columns).
//
// SKETCHES: 179 artists per nslists' post-release roster — the official PDF
// announced ~177 and differs on a handful of rows (e.g. it lists "Darren
// James" where nslists has "Darren Coburn-James", and omits late additions
// like Basak Çetinkaya and Jonarton); nslists kept.
// =============================================================================

export const SETS = [
  {
    id: "base",
    type: "base",
    title: "BASE — CONTINUES 2017 GALACTIC FILES REBORN NUMBERING",
    parallels: [
        { id: "orange", name: "Orange", print_run: null, color: "#ff9100" },
        { id: "blue", name: "Blue", print_run: null, color: "#2979ff" },
        { id: "green", name: "Green", print_run: 199, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 99, color: "#b388ff" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "white", name: "White", print_run: 5, color: "#e8eaf0" },
        { id: "red", name: "Red", print_run: 1, color: "#ff1744" },
      ],
    cards: [
        { n: "TPM-26", name: "Anakin Skywalker" },
        { n: "TPM-27", name: "Yoda" },
        { n: "TPM-28", name: "Mace Windu" },
        { n: "TPM-29", name: "Senator Palpatine" },
        { n: "TPM-30", name: "Yaddle" },
        { n: "AOTC-21", name: "Anakin Skywalker" },
        { n: "AOTC-22", name: "Obi-Wan Kenobi" },
        { n: "AOTC-23", name: "Padmé Amidala" },
        { n: "AOTC-24", name: "Yoda" },
        { n: "AOTC-25", name: "Queen Jamillia" },
        { n: "ACW-22", name: "Zillo Beast" },
        { n: "ACW-23", name: "Commander Gree" },
        { n: "ACW-24", name: "Commander Fox" },
        { n: "ACW-25", name: "Luminara Unduli" },
        { n: "ACW-26", name: "Barriss Offee" },
        { n: "ACW-27", name: "Seripas" },
        { n: "ACW-28", name: "Professor Huyang" },
        { n: "ACW-29", name: "Darth Bane" },
        { n: "ACW-30", name: "Bossk" },
        { n: "ACW-31", name: "Chancellor Palpatine" },
        { n: "ACW-32", name: "Sugi" },
        { n: "ACW-33", name: "Lok Durd" },
        { n: "ACW-34", name: "Dengar" },
        { n: "ACW-35", name: "Latts Razzi" },
        { n: "ACW-36", name: "Embo" },
        { n: "ACW-37", name: "Rumi Paramita" },
        { n: "ACW-38", name: "Aurra Sing" },
        { n: "ACW-39", name: "Gha Nachkt" },
        { n: "ACW-40", name: "Todo 360" },
        { n: "ACW-41", name: "Queen Miraj Scintel" },
        { n: "ROTS-19", name: "Darth Vader" },
        { n: "ROTS-20", name: "Governor Tarkin" },
        { n: "ROTS-21", name: "Obi-Wan Kenobi" },
        { n: "ROTS-22", name: "Mon Mothma" },
        { n: "ROTS-23", name: "Terr Taneel" },
        { n: "REB-16", name: "Ahsoka Tano" },
        { n: "REB-17", name: "Grand Admiral Thrawn" },
        { n: "REB-18", name: "Commander Jun Sato" },
        { n: "REB-19", name: "Eighth Brother" },
        { n: "REB-20", name: "Klik-Klak" },
        { n: "REB-21", name: "Governor Arihnda Pryce" },
        { n: "REB-22", name: "Yogar Lyste" },
        { n: "REB-23", name: "Fenn Rau" },
        { n: "REB-24", name: "Bendu" },
        { n: "REB-25", name: "Darth Maul" },
        { n: "REB-26", name: "AP-5" },
        { n: "REB-27", name: "Gall Trayvis" },
        { n: "REB-28", name: "Ryder Azadi" },
        { n: "REB-29", name: "Azmorigan" },
        { n: "REB-30", name: "Tristan Wren" },
        { n: "REB-31", name: "Ursa Wren" },
        { n: "REB-32", name: "Gar Saxon" },
        { n: "REB-33", name: "Colonel Yularen" },
        { n: "REB-34", name: "Gooti Terez" },
        { n: "REB-35", name: "RX-24" },
        { n: "REB-36", name: "Mart Mattin" },
        { n: "REB-37", name: "Obi-Wan Kenobi" },
        { n: "REB-38", name: "Ketsu Onyo" },
        { n: "REB-39", name: "Numa" },
        { n: "REB-40", name: "Vult Skerris" },
        { n: "REB-41", name: "Rukh" },
        { n: "RO-9", name: "Jyn Erso" },
        { n: "RO-10", name: "Galen Erso" },
        { n: "RO-11", name: "Mon Mothma" },
        { n: "RO-12", name: "Death Trooper" },
        { n: "RO-13", name: "Pao" },
        { n: "RO-14", name: "Bistan" },
        { n: "RO-15", name: "K-2SO" },
        { n: "RO-16", name: "Darth Vader" },
        { n: "RO-17", name: "Edrio Two Tubes" },
        { n: "RO-18", name: "Benthic Two Tubes" },
        { n: "RO-19", name: "General Merrick" },
        { n: "RO-20", name: "General Draven" },
        { n: "RO-21", name: "Shollan" },
        { n: "RO-22", name: "Caitken" },
        { n: "RO-23", name: "General Jan Dodonna" },
        { n: "RO-24", name: "Sergeant Melshi" },
        { n: "RO-25", name: "Corporal Tonc" },
        { n: "RO-26", name: "Tivik" },
        { n: "RO-27", name: "Lyra Erso" },
        { n: "RO-28", name: "Admiral Raddus" },
        { n: "RO-29", name: "Senator Jebel" },
        { n: "RO-30", name: "Ralo Surrel" },
        { n: "RO-31", name: "Harb Binli" },
        { n: "RO-32", name: "Lt. Zal Dinnes" },
        { n: "RO-33", name: "General Hurst Romodi" },
        { n: "RO-34", name: "Farns Monsbee" },
        { n: "RO-35", name: "Pedrin Gaul" },
        { n: "RO-36", name: "Oolin Musters" },
        { n: "RO-37", name: "Vaneé" },
        { n: "RO-38", name: "General Ramda" },
        { n: "RO-39", name: "Barion Raner" },
        { n: "RO-40", name: "Toshdor Ni" },
        { n: "RO-41", name: "Nesta Term" },
        { n: "RO-42", name: "Moroff" },
        { n: "RO-43", name: "Shoretrooper" },
        { n: "RO-44", name: "Laren Joma" },
        { n: "RO-45", name: "Senator Vaspar" },
        { n: "RO-46", name: "Senator Pamlo" },
        { n: "RO-47", name: "Weeteef Cyu-Bee" },
        { n: "RO-48", name: "Lieutenant Sefla" },
        { n: "RO-49", name: "Killi Gimm" },
        { n: "RO-50", name: "Bail Organa" },
        { n: "RO-51", name: "K-OHN" },
        { n: "RO-52", name: "Corporal Ansin Thobel" },
        { n: "ANH-30", name: "Death Star Trooper" },
        { n: "ANH-31", name: "Death Star Gunner" },
        { n: "ANH-32", name: "General Tagge" },
        { n: "ANH-33", name: "Commander Daine Jir" },
        { n: "ANH-34", name: "General Willard" },
        { n: "ANH-35", name: "John D. Branon" },
        { n: "ANH-36", name: "Figrin D'an" },
        { n: "ANH-37", name: "Mosep Binneed" },
        { n: "ANH-38", name: "Leesub Sirln" },
        { n: "ANH-39", name: "Nabrun Leids" },
        { n: "ANH-40", name: "Kabe" },
        { n: "ANH-41", name: "Muftak" },
        { n: "ANH-42", name: "Pons Limbic" },
        { n: "ANH-43", name: "Bom Vimdin" },
        { n: "ANH-44", name: "Djas Puhr" },
        { n: "ANH-45", name: "Elis Helrot" },
        { n: "ANH-46", name: "Feltipern Trevagg" },
        { n: "ANH-47", name: "Labria" },
        { n: "ESB-17", name: "Darth Vader" },
        { n: "ESB-18", name: "The Emperor" },
        { n: "ESB-19", name: "Princess Leia Organa" },
        { n: "ESB-20", name: "Luke Skywalker" },
        { n: "ESB-21", name: "Han Solo" },
        { n: "ESB-22", name: "C-3PO" },
        { n: "ESB-23", name: "R2-D2" },
        { n: "ESB-24", name: "Captain Needa" },
        { n: "ESB-25", name: "Obi-Wan Kenobi" },
        { n: "ESB-26", name: "Imperial Snowtrooper" },
        { n: "ESB-27", name: "Imperial AT-AT Pilot" },
        { n: "ESB-28", name: "Space Slug" },
        { n: "ESB-29", name: "FX-7" },
        { n: "ESB-30", name: "Tauntaun" },
        { n: "ROTJ-19", name: "Chief Chirpa" },
        { n: "ROTJ-20", name: "R2-Q5" },
        { n: "ROTJ-21", name: "Chewbacca" },
        { n: "ROTJ-22", name: "Logray" },
        { n: "ROTJ-23", name: "Rancor" },
        { n: "ROTJ-24", name: "Yoda" },
        { n: "ROTJ-25", name: "Lando Calrissian" },
        { n: "ROTJ-26", name: "Boba Fett" },
        { n: "ROTJ-27", name: "Lieutenant Endicott" },
        { n: "ROTJ-28", name: "Boushh" },
        { n: "ROTJ-29", name: "J'Quille" },
        { n: "ROTJ-30", name: "Barada" },
        { n: "ROTJ-31", name: "Han Solo In Carbonite" },
        { n: "ROTJ-32", name: "Klaatu" },
        { n: "ROTJ-33", name: "Ephant Mon" },
        { n: "TFA-31", name: "Bazine Netal" },
        { n: "TFA-32", name: "Prashee" },
        { n: "TFA-33", name: "Wollivan" },
        { n: "TFA-34", name: "Praster Ommlen" },
        { n: "TFA-35", name: "Gwellis Bagnoro" },
        { n: "TFA-36", name: "Grummgar" },
        { n: "TFA-37", name: "Sidon Ithano" },
        { n: "TFA-38", name: "Quiggold" },
        { n: "TFA-39", name: "Sarco Plank" },
        { n: "TFA-40", name: "Doctor Kalonia" },
        { n: "TFA-41", name: "First Order Stormtrooper" },
        { n: "TFA-42", name: "Chancellor Villecham" },
        { n: "TFA-43", name: "Petty Officer Thanisson" },
        { n: "TFA-44", name: "Kaydel Ko Connix" },
        { n: "TFA-45", name: "Colonel Datoo" },
        { n: "TFA-46", name: "Guavian Death Gang Enforcer" },
        { n: "TFA-47", name: "Ensign Pamich Nerro Goode" },
        { n: "TFA-48", name: "Korr Sella" },
        { n: "TFA-49", name: "Teedo" },
        { n: "TFA-50", name: "Bobbajo" },
        { n: "TFA-51", name: "Goss Toowers" },
        { n: "TFA-52", name: "Jashco Phurus" },
        { n: "TFA-53", name: "Strono \"Cookie\" Tuggs" },
        { n: "TFA-54", name: "Hassk Triplets" },
        { n: "TFA-55", name: "First Order Snowtrooper" },
        { n: "TFA-56", name: "Admiral Ackbar" },
        { n: "TFA-57", name: "Nien Nunb" },
        { n: "TFA-58", name: "Ilco Munica" },
        { n: "TLJ-1", name: "Luke Skywalker" },
        { n: "TLJ-2", name: "Rey" },
        { n: "TLJ-3", name: "Kylo Ren" },
        { n: "TLJ-4", name: "Finn" },
        { n: "TLJ-5", name: "Rose Tico" },
        { n: "TLJ-6", name: "Captain Phasma" },
        { n: "TLJ-7", name: "General Leia Organa" },
        { n: "TLJ-8", name: "R2-D2" },
        { n: "TLJ-9", name: "C-3PO" },
        { n: "TLJ-10", name: "Chewbacca" },
        { n: "TLJ-11", name: "General Hux" },
        { n: "TLJ-12", name: "Poe Dameron" },
        { n: "TLJ-13", name: "DJ" },
        { n: "TLJ-14", name: "Paige Tico" },
        { n: "TLJ-15", name: "Executioner Stormtrooper" },
        { n: "TLJ-16", name: "Caretaker" },
        { n: "TLJ-17", name: "BB-8" },
        { n: "TLJ-18", name: "BB-9E" },
        { n: "TLJ-19", name: "Kaydel Ko Connix" },
        { n: "TLJ-20", name: "General Ematt" },
    ],
  },
  {
    id: "base-image-variations",
    type: "insert",
    title: "2017 BASE IMAGE VARIATIONS — SHORT PRINTS",
    parallels: [],
    cards: [
        { n: "TPM-2", name: "Obi-Wan Kenobi" },
        { n: "TPM-4", name: "Darth Maul" },
        { n: "AOTC-2", name: "Mace Windu" },
        { n: "ACW-1", name: "Ahsoka Tano" },
        { n: "ACW-6", name: "Asajj Ventress" },
        { n: "ROTS-1", name: "Anakin Skywalker" },
        { n: "ROTS-5", name: "Yoda" },
        { n: "REB-1", name: "Kanan Jarrus" },
        { n: "REB-2", name: "Hera Syndulla" },
        { n: "REB-6", name: "Ezra Bridger" },
        { n: "REB-7", name: "The Grand Inquisitor" },
        { n: "ANH-3", name: "Imperial Stormtroopers" },
        { n: "ANH-5", name: "Princess Leia" },
        { n: "ANH-6", name: "Darth Vader" },
        { n: "ANH-10", name: "Luke Skywalker" },
        { n: "ANH-14", name: "Grand Moff Tarkin" },
        { n: "ESB-1", name: "Boba Fett" },
        { n: "ESB-3", name: "Lando Calrissian" },
        { n: "ROTJ-3", name: "Wicket W. Warrick" },
        { n: "TFA-1", name: "Rey" },
        { n: "TFA-2", name: "Finn" },
        { n: "TFA-3", name: "Kylo Ren" },
        { n: "TFA-7", name: "Poe Dameron" },
        { n: "TFA-8", name: "Han Solo" },
        { n: "TFA-11", name: "Chewbacca" },
    ],
  },
  {
    id: "band-of-heroes",
    type: "insert",
    title: "BAND OF HEROES",
    parallels: [
        { id: "purple", name: "Purple", print_run: 99, color: "#b388ff" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "white", name: "White", print_run: 5, color: "#e8eaf0" },
      ],
    cards: [
        { n: "BH-1", name: "The Jedi Order" },
        { n: "BH-2", name: "The Galactic Republic" },
        { n: "BH-3", name: "The Rebel Alliance" },
        { n: "BH-4", name: "Saw Gerrera's Militia" },
        { n: "BH-5", name: "Phoenix Squadron" },
        { n: "BH-6", name: "Free Ryloth Movement" },
        { n: "BH-7", name: "The Resistance" },
    ],
  },
  {
    id: "galactic-moments",
    type: "insert",
    title: "GALACTIC MOMENTS",
    parallels: [
        { id: "purple", name: "Purple", print_run: 99, color: "#b388ff" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "white", name: "White", print_run: 5, color: "#e8eaf0" },
      ],
    cards: [
        { n: "GM-1", name: "Rey Defeats Kylo Ren" },
        { n: "GM-2", name: "Meeting Han Solo" },
        { n: "GM-3", name: "Escaping the Space Slug" },
        { n: "GM-4", name: "Luke Skywalker Surrenders to Darth Vader" },
        { n: "GM-5", name: "Anakin Skywalker Becomes Darth Vader" },
        { n: "GM-6", name: "Death Star Test on Jedha" },
        { n: "GM-7", name: "Yoda Duels Count Dooku" },
        { n: "GM-8", name: "The Sith Return" },
        { n: "GM-9", name: "Queen Amidala Ensnares Nute Gunray" },
        { n: "GM-10", name: "Rey and Kylo Ren Confront Supreme Leader Snoke" },
    ],
  },
  {
    id: "locations",
    type: "insert",
    title: "LOCATIONS",
    parallels: [
        { id: "purple", name: "Purple", print_run: 99, color: "#b388ff" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "white", name: "White", print_run: 5, color: "#e8eaf0" },
      ],
    cards: [
        { n: "L-1", name: "Mos Eisley Cantina" },
        { n: "L-2", name: "Cloud City Gantry" },
        { n: "L-3", name: "The Emperor's Throne Room" },
        { n: "L-4", name: "Watto's Shop" },
        { n: "L-5", name: "Kamino Cloning Chamber" },
        { n: "L-6", name: "Palpatine's Office" },
        { n: "L-7", name: "Rey's AT-AT" },
        { n: "L-8", name: "Starkiller Base" },
        { n: "L-9", name: "Imperial Data Vault" },
        { n: "L-10", name: "The Ahch-To Library" },
    ],
  },
  {
    id: "memorable-quotes",
    type: "insert",
    title: "MEMORABLE QUOTES",
    parallels: [
        { id: "purple", name: "Purple", print_run: 99, color: "#b388ff" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "white", name: "White", print_run: 5, color: "#e8eaf0" },
      ],
    cards: [
        { n: "MQ-1", name: "\"Chewie, we're home\"", artist: "Han Solo" },
        { n: "MQ-2", name: "\"What if he doesn't survive, he's worth a lot to me\"", artist: "Boba Fett" },
        { n: "MQ-3", name: "\"You, like your father, are now... mine!\"", artist: "Emperor Palpatine" },
        { n: "MQ-4", name: "\"This deal is getting worse all the time!\"", artist: "Lando Calrissian" },
        { n: "MQ-5", name: "\"Why you stuck-up, half-witted scruffy-looking nerf herder!\"", artist: "Princess Leia" },
        { n: "MQ-6", name: "\"The greatest teacher, failure is\"", artist: "Yoda" },
        { n: "MQ-7", name: "\"I need someone to show me my place in all this\"", artist: "Rey" },
        { n: "MQ-8", name: "\"Permission to jump in an X-wing and blow something up?\"", artist: "Poe Dameron" },
        { n: "MQ-9", name: "\"Be careful not to choke on your... aspirations.\"", artist: "Darth Vader" },
        { n: "MQ-10", name: "\"See you around, kid.\"", artist: "Luke Skywalker" },
    ],
  },
  {
    id: "sinister-syndicates",
    type: "insert",
    title: "SINISTER SYNDICATES",
    parallels: [
        { id: "purple", name: "Purple", print_run: 99, color: "#b388ff" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "white", name: "White", print_run: 5, color: "#e8eaf0" },
      ],
    cards: [
        { n: "SS-1", name: "The First Order" },
        { n: "SS-2", name: "Death Watch" },
        { n: "SS-3", name: "Weequay Pirates" },
        { n: "SS-4", name: "Black Sun" },
        { n: "SS-5", name: "Bounty Hunters" },
        { n: "SS-6", name: "Pyke Syndicate" },
        { n: "SS-7", name: "Nightbrothers" },
        { n: "SS-8", name: "Nightsisters" },
        { n: "SS-9", name: "Broken Horn Syndicate" },
        { n: "SS-10", name: "Guavian Death Gang" },
        { n: "SS-11", name: "Inquisitors" },
        { n: "SS-12", name: "Zygerrian Slave Empire" },
        { n: "SS-13", name: "Kanjiklub" },
        { n: "SS-14", name: "Meson Martinet Crew" },
        { n: "SS-15", name: "Separatist Council" },
    ],
  },
  {
    id: "vehicles",
    type: "insert",
    title: "VEHICLES",
    parallels: [
        { id: "purple", name: "Purple", print_run: 99, color: "#b388ff" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "white", name: "White", print_run: 5, color: "#e8eaf0" },
      ],
    cards: [
        { n: "V-1", name: "Millennium Falcon" },
        { n: "V-2", name: "Y-Wing Fighter" },
        { n: "V-3", name: "TIE Interceptor" },
        { n: "V-4", name: "Naboo Starfighter" },
        { n: "V-5", name: "Jedi Starfighter" },
        { n: "V-6", name: "Count Dooku's Solar Sailer" },
        { n: "V-7", name: "Krennic's Shuttle" },
        { n: "V-8", name: "U-Wing Gunship" },
        { n: "V-9", name: "Resistance Bomber" },
        { n: "V-10", name: "First Order Dreadnought" },
    ],
  },
  {
    id: "weapons",
    type: "insert",
    title: "WEAPONS",
    parallels: [
        { id: "purple", name: "Purple", print_run: 99, color: "#b388ff" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "white", name: "White", print_run: 5, color: "#e8eaf0" },
      ],
    cards: [
        { n: "W-1", name: "Princess Leia's Sporting Blaster" },
        { n: "W-2", name: "Luke Skywalker's Lightsaber" },
        { n: "W-3", name: "Obi-Wan Kenobi's Lightsaber" },
        { n: "W-4", name: "Westar-34 Blaster" },
        { n: "W-5", name: "EE-3 Blaster Rifle" },
        { n: "W-6", name: "Chirrut Îmwe's Staff" },
        { n: "W-7", name: "Jyn Erso's Blaster" },
        { n: "W-8", name: "BlasTech SE-14r" },
        { n: "W-9", name: "Laser Ax" },
        { n: "W-10", name: "GLIE-44 Blaster Pistol" },
    ],
  },
  {
    id: "autograph-cards",
    type: "auto",
    title: "AUTOGRAPHS",
    parallels: [
        { id: "green", name: "Green", print_run: 50, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 25, color: "#b388ff" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "white", name: "White", print_run: 5, color: "#e8eaf0" },
        { id: "red", name: "Red", print_run: 1, color: "#ff1744" },
      ],
    cards: [
        { n: "A-AD", name: "Adam Driver", artist: "Kylo Ren" },
        { n: "A-AT", name: "Alan Tudyk", artist: "K-2SO" },
        { n: "A-AP", name: "Alistair Petrie", artist: "General Draven" },
        { n: "A-ADT", name: "Andy De La Tour", artist: "General Hurst Romodi" },
        { n: "A-AG", name: "Anna Graves", artist: "Duchess Satine Kryze" },
        { n: "A-ADA", name: "Anthony Daniels", artist: "C-3PO" },
        { n: "A-AB", name: "Ariyon Bakare", artist: "Barion Raner (Blue Four)" },
        { n: "A-AE", name: "Ashley Eckstein", artist: "Ahsoka Tano" },
        { n: "A-BG", name: "Barbara Goodson", artist: "Mother Talzin" },
        { n: "A-BDW", name: "Billy Dee Williams", artist: "Lando Calrissian" },
        { n: "A-BP", name: "Bonnie Piesse", artist: "Beru Whitesun" },
        { n: "A-CF", name: "Carrie Fisher", artist: "General Leia Organa" },
        { n: "A-CA", name: "Cas Anvar", artist: "Peteen" },
        { n: "A-CR", name: "Clive Revill", artist: "The Emperor (Voice)" },
        { n: "A-DR", name: "Daisy Ridley", artist: "Rey" },
        { n: "A-DM", name: "Daniel Mays", artist: "Tivik" },
        { n: "A-DT", name: "David Tennant", artist: "Professor Huyang" },
        { n: "A-DY", name: "Donnie Yen", artist: "Chirrut Îmwe" },
        { n: "A-FJ", name: "Felicity Jones", artist: "Jyn Erso" },
        { n: "A-FW", name: "Forest Whitaker", artist: "Saw Gerrera" },
        { n: "A-FPJ", name: "Freddie Prinze Jr.", artist: "Kanan Jarrus" },
        { n: "A-GT", name: "George Takei", artist: "Lok Durd" },
        { n: "A-GG", name: "Greg Grunberg", artist: "Snap Wexley" },
        { n: "A-GC", name: "Gwendoline Christie", artist: "Captain Phasma" },
        { n: "A-HF", name: "Harrison Ford", artist: "Han Solo" },
        { n: "A-HC", name: "Hayden Christensen", artist: "Anakin Skywalker" },
        { n: "A-HS", name: "Hugh Skinner", artist: "Geno Namit" },
        { n: "A-IM", name: "Ian McDiarmid", artist: "Darth Sidious" },
        { n: "A-JL", name: "Jett Lucas", artist: "Zett Jukassa" },
        { n: "A-JB", name: "John Boyega", artist: "Finn" },
        { n: "A-JSC", name: "Jordan Stephens", artist: "Corporal Tonc" },
        { n: "A-KF", name: "Kate Fleetwood", artist: "Chief Petty Officer Unamo" },
        { n: "A-KB", name: "Kenny Baker", artist: "R2-D2" },
        { n: "A-KR", name: "Kipsang Rotich", artist: "Nien Nunb (Voice)" },
        { n: "A-LD", name: "Laura Dern", artist: "Vice Admiral Holdo" },
        { n: "A-MSA", name: "Marc Silk", artist: "Aks Moe (Voice)" },
        { n: "A-MS", name: "Meredith Salenger", artist: "Barriss Offee" },
        { n: "A-RP", name: "Ray Park", artist: "Darth Maul" },
        { n: "A-RA", name: "Riz Ahmed", artist: "Bodhi Rook" },
        { n: "A-RD", name: "Robbie Daymond", artist: "Eighth Brother" },
        { n: "A-RN", name: "Robert Nairne", artist: "Kullbee Sperado" },
        { n: "A-SMG", name: "Sarah Michelle Gellar", artist: "Seventh Sister" },
        { n: "A-TM", name: "Temuera Morrison", artist: "Jango Fett" },
        { n: "A-VK", name: "Valene Kane", artist: "Lyra Erso" },
    ],
  },
  {
    id: "dual-autographs",
    type: "auto",
    title: "DUAL AUTOGRAPHS",
    parallels: [
        { id: "purple", name: "Purple", print_run: 25, color: "#b388ff" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "white", name: "White", print_run: 5, color: "#e8eaf0" },
      ],
    cards: [
        { n: "DA-RB", name: "Daisy Ridley / John Boyega", artist: "Rey / Finn" },
        { n: "DA-JW", name: "Felicity Jones / Forest Whitaker", artist: "Jyn Erso / Saw Gerrera" },
        { n: "DA-TB", name: "George Takei / Dee Bradley Baker", artist: "Lok Durd / Captain Rex" },
        { n: "DA-FF", name: "Harrison Ford / Carrie Fisher", artist: "Han Solo / Leia Organa" },
        { n: "DA-TL", name: "James Arnold Taylor / Matt Lanter", artist: "Obi-Wan Kenobi / Anakin Skywalker" },
        { n: "DA-AT", name: "Riz Ahmed / Alan Tudyk", artist: "Bodhi Rook / K-2SO" },
        { n: "DA-GB", name: "Taylor Gray / Steven Blum", artist: "Ezra Bridger / Zeb Orrelios" },
        { n: "DA-RQ", name: "Tim Rose / Mike Quinn", artist: "Admiral Ackbar / Nien Nunb" },
        { n: "DA-KL", name: "Tom Kenny / Phil LaMarr", artist: "Nahdar Vebb / Kit Fisto" },
    ],
  },
  {
    id: "triple-autographs",
    type: "auto",
    title: "TRIPLE AUTOGRAPHS",
    parallels: [
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "white", name: "White", print_run: 5, color: "#e8eaf0" },
      ],
    cards: [
        { n: "TA-WQM", name: "Billy Dee Williams / Mike Quinn / Peter Mayhew", artist: "Lando Calrissian / Nien Nunb / Chewbacca" },
        { n: "TA-MMB", name: "Lars Mikkelsen / Mary Elizabeth McGlynn / Dee Bradley Baker", artist: "Grand Admiral Thrawn / Governor Arihnda Pryce / Admiral Kassius Konstantine" },
    ],
  },
  {
    id: "six-person-autograph",
    type: "auto",
    title: "SIX-PERSON AUTOGRAPH",
    parallels: [],
    cards: [
        { n: "SPA-1", name: "Felicity Jones / Forest Whitaker / Riz Ahmed / Donnie Yen / Alan Tudyk / Genevieve O'Reilly", artist: "Jyn Erso / Saw Gerrera / Bodhi Rook / Chirrut Îmwe / K-2SO / Mon Mothma" },
    ],
  },
  {
    id: "fabric-swatches",
    type: "insert",
    title: "SOURCE MATERIAL FABRIC SWATCHES",
    parallels: [
        { id: "numbered", name: "", print_run: 50, color: "#c8d8f0" },
        { id: "purple", name: "Purple", print_run: 25, color: "#b388ff" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "white", name: "White", print_run: 5, color: "#e8eaf0" },
        { id: "red", name: "Red", print_run: 1, color: "#ff1744" },
      ],
    cards: [
        { n: "CR-C", name: "Caretaker", artist: "Uniform" },
        { n: "CR-GE", name: "Galen Erso", artist: "Jacket" },
        { n: "CR-GM", name: "General Merrick", artist: "Suit Sleeve" },
        { n: "CR-JE", name: "Jyn Erso", artist: "Poncho" },
        { n: "CR-PD", name: "Poe Dameron", artist: "Shirt" },
        { n: "CR-PG", name: "Praetorian Guard", artist: "Uniform" },
        { n: "CR-RH", name: "Rey", artist: "Head Wrap" },
        { n: "CR-RJ", name: "Rey", artist: "Jacket" },
    ],
  },
  {
    id: "movie-poster-patches",
    type: "insert",
    title: "MANUFACTURED MOVIE POSTER PATCH CARDS",
    parallels: [
        { id: "blue", name: "Blue", print_run: 99, color: "#2979ff" },
        { id: "green", name: "Green", print_run: 50, color: "#00e676" },
        { id: "purple", name: "Purple", print_run: 25, color: "#b388ff" },
        { id: "gold", name: "Gold", print_run: 10, color: "#f0c040" },
        { id: "white", name: "White", print_run: 5, color: "#e8eaf0" },
        { id: "red", name: "Red", print_run: 1, color: "#ff1744" },
      ],
    cards: [
        { n: "MA-AA", name: "Admiral Ackbar", artist: "Return of the Jedi" },
        { n: "MA-ASM", name: "Anakin Skywalker", artist: "The Phantom Menace" },
        { n: "MA-AS", name: "Anakin Skywalker", artist: "Attack of the Clones" },
        { n: "MA-ASR", name: "Anakin Skywalker", artist: "Revenge of the Sith" },
        { n: "MA-BM", name: "Baze Malbus", artist: "Rogue One" },
        { n: "MA-BF", name: "Boba Fett", artist: "The Empire Strikes Back" },
        { n: "MA-BR", name: "Bodhi Rook", artist: "Rogue One" },
        { n: "MA-CPO", name: "C-3PO", artist: "A New Hope" },
        { n: "MA-CP", name: "Captain Phasma", artist: "The Force Awakens" },
        { n: "MA-CA", name: "Cassian Andor", artist: "Rogue One" },
        { n: "MA-CI", name: "Chirrut Îmwe", artist: "Rogue One" },
        { n: "MA-CD", name: "Count Dooku", artist: "Attack of the Clones" },
        { n: "MA-DM", name: "Darth Maul", artist: "The Phantom Menace" },
        { n: "MA-DS", name: "Darth Sidious", artist: "Revenge of the Sith" },
        { n: "MA-DVS", name: "Darth Vader", artist: "Revenge of the Sith" },
        { n: "MA-DV", name: "Darth Vader", artist: "The Empire Strikes Back" },
        { n: "MA-DK", name: "Director Krennic", artist: "Rogue One" },
        { n: "MA-F", name: "Finn", artist: "The Force Awakens" },
        { n: "MA-FJ", name: "Finn", artist: "The Last Jedi" },
        { n: "MA-GGS", name: "General Grievous", artist: "Revenge of the Sith" },
        { n: "MA-GH", name: "General Hux", artist: "The Last Jedi" },
        { n: "MA-LOF", name: "General Leia Organa", artist: "The Force Awakens" },
        { n: "MA-GMT", name: "Grand Moff Tarkin", artist: "A New Hope" },
        { n: "MA-HSH", name: "Han Solo", artist: "A New Hope" },
        { n: "MA-HSE", name: "Han Solo", artist: "The Empire Strikes Back" },
        { n: "MA-HS", name: "Han Solo", artist: "Return of the Jedi" },
        { n: "MA-HSF", name: "Han Solo", artist: "The Force Awakens" },
        { n: "MA-JTH", name: "Jabba The Hutt", artist: "Return of the Jedi" },
        { n: "MA-JF", name: "Jango Fett", artist: "Attack of the Clones" },
        { n: "MA-JE", name: "Jyn Erso", artist: "Rogue One" },
        { n: "MA-KRF", name: "Kylo Ren", artist: "The Force Awakens" },
        { n: "MA-KR", name: "Kylo Ren", artist: "The Last Jedi" },
        { n: "MA-LC", name: "Lando Calrissian", artist: "The Empire Strikes Back" },
        { n: "MA-LS", name: "Luke Skywalker", artist: "A New Hope" },
        { n: "MA-LSH", name: "Luke Skywalker", artist: "The Empire Strikes Back" },
        { n: "MA-LSR", name: "Luke Skywalker", artist: "Return of the Jedi" },
        { n: "MA-LSJ", name: "Luke Skywalker", artist: "The Last Jedi" },
        { n: "MA-OWK", name: "Obi-Wan Kenobi", artist: "The Phantom Menace" },
        { n: "MA-OKC", name: "Obi-Wan Kenobi", artist: "Attack of the Clones" },
        { n: "MA-OKS", name: "Obi-Wan Kenobi", artist: "Revenge of the Sith" },
        { n: "MA-OKH", name: "Obi-Wan Kenobi", artist: "A New Hope" },
        { n: "MA-PAC", name: "Padmé Amidala", artist: "Attack of the Clones" },
        { n: "MA-PD", name: "Poe Dameron", artist: "The Force Awakens" },
        { n: "MA-PDJ", name: "Poe Dameron", artist: "The Last Jedi" },
        { n: "MA-PLO", name: "Princess Leia Organa", artist: "A New Hope" },
        { n: "MA-LO", name: "Princess Leia Organa", artist: "The Empire Strikes Back" },
        { n: "MA-LOJ", name: "Princess Leia Organa", artist: "Return of the Jedi" },
        { n: "MA-PA", name: "Queen Amidala", artist: "The Phantom Menace" },
        { n: "MA-QGJ", name: "Qui-Gon Jinn", artist: "The Phantom Menace" },
        { n: "MA-RD", name: "R2-D2", artist: "A New Hope" },
        { n: "MA-R", name: "Rey", artist: "The Force Awakens" },
        { n: "MA-RJ", name: "Rey", artist: "The Last Jedi" },
        { n: "MA-SG", name: "Saw Gerrera", artist: "Rogue One" },
        { n: "MA-SLS", name: "Supreme Leader Snoke", artist: "The Last Jedi" },
        { n: "MA-TE", name: "The Emperor", artist: "Return of the Jedi" },
        { n: "MA-Y", name: "Yoda", artist: "The Empire Strikes Back" },
    ],
  },
  {
    id: "sketch-cards",
    type: "sketch",
    title: "SKETCH ARTISTS",
    parallels: [
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SK-1", name: "Aaron Laurich" },
        { n: "SK-2", name: "Adam Harris" },
        { n: "SK-3", name: "Adam Worton" },
        { n: "SK-4", name: "Adrian Ropp" },
        { n: "SK-5", name: "Albert Nguyen" },
        { n: "SK-6", name: "Aleksandar Gigov" },
        { n: "SK-7", name: "Alex Mines" },
        { n: "SK-8", name: "Allen Grimes" },
        { n: "SK-9", name: "Allysa Pirone" },
        { n: "SK-10", name: "Andrew Arensberg" },
        { n: "SK-11", name: "Andrew Fry" },
        { n: "SK-12", name: "Andrew Lopez" },
        { n: "SK-13", name: "Andy Bohn" },
        { n: "SK-14", name: "Angelina Benedetti" },
        { n: "SK-15", name: "Anil Sharma" },
        { n: "SK-16", name: "Ashleigh Popplewell" },
        { n: "SK-17", name: "Barry Renshaw" },
        { n: "SK-18", name: "Basak Çetinkaya" },
        { n: "SK-19", name: "Ben AbuSaada" },
        { n: "SK-20", name: "Bill Pulkovski" },
        { n: "SK-21", name: "Bobby Blakey" },
        { n: "SK-22", name: "Brad Hudson" },
        { n: "SK-23", name: "Brandon Blevins" },
        { n: "SK-24", name: "Brendan Purchase" },
        { n: "SK-25", name: "Brendan Shaw" },
        { n: "SK-26", name: "Brent Ragland" },
        { n: "SK-27", name: "Brent Scotchmer" },
        { n: "SK-28", name: "Brett Farr" },
        { n: "SK-29", name: "Bruce Gerlach" },
        { n: "SK-30", name: "Bryce King II" },
        { n: "SK-31", name: "Caleb King" },
        { n: "SK-32", name: "Carlos Cabaleiro" },
        { n: "SK-33", name: "Carolyn Craggs" },
        { n: "SK-34", name: "Chad LaForce" },
        { n: "SK-35", name: "Chad Scheres" },
        { n: "SK-36", name: "Chris Thorne" },
        { n: "SK-37", name: "Chris Willdig" },
        { n: "SK-38", name: "Christian Parker" },
        { n: "SK-39", name: "Clinton Yeager" },
        { n: "SK-40", name: "Colin Arthurs" },
        { n: "SK-41", name: "Corey Galal" },
        { n: "SK-42", name: "Dan Bergren" },
        { n: "SK-43", name: "Dan Curto" },
        { n: "SK-44", name: "Dan Gorman" },
        { n: "SK-45", name: "Dan Tearle" },
        { n: "SK-46", name: "Darren Coburn-James" },
        { n: "SK-47", name: "Darrin Pepe" },
        { n: "SK-48", name: "Dave Fowler" },
        { n: "SK-49", name: "Dave Holtz" },
        { n: "SK-50", name: "Dave Strong" },
        { n: "SK-51", name: "David Angelo Roman" },
        { n: "SK-52", name: "Dean Drummond" },
        { n: "SK-53", name: "Desiree Portner" },
        { n: "SK-54", name: "Dylan Riley" },
        { n: "SK-55", name: "Edward Santia" },
        { n: "SK-56", name: "Elfie Lebouleux" },
        { n: "SK-57", name: "Eric Lehtonen" },
        { n: "SK-58", name: "Eric White" },
        { n: "SK-59", name: "Fredd Gorham" },
        { n: "SK-60", name: "Garrett Dix" },
        { n: "SK-61", name: "Gavin Williams" },
        { n: "SK-62", name: "Gerard Garcia Jr." },
        { n: "SK-63", name: "Glenn Porzig" },
        { n: "SK-64", name: "Glenn Savage" },
        { n: "SK-65", name: "Görkem Demir" },
        { n: "SK-66", name: "Greg Mitchell" },
        { n: "SK-67", name: "Huy Truong" },
        { n: "SK-68", name: "Ian MacDougal" },
        { n: "SK-69", name: "Ibrahim Özkan" },
        { n: "SK-70", name: "Ingrid Hardy" },
        { n: "SK-71", name: "Jaime Lopez" },
        { n: "SK-72", name: "James Henry Smith" },
        { n: "SK-73", name: "Jamie Cosley" },
        { n: "SK-74", name: "Jamie Richards" },
        { n: "SK-75", name: "Jason Adams" },
        { n: "SK-76", name: "Jason Brower" },
        { n: "SK-77", name: "Jason Miller" },
        { n: "SK-78", name: "Jason Queen" },
        { n: "SK-79", name: "Jason Sobol" },
        { n: "SK-80", name: "Jay Manchand" },
        { n: "SK-81", name: "Jeff Abar" },
        { n: "SK-82", name: "Jessica Hickman" },
        { n: "SK-83", name: "Jim Mehsling" },
        { n: "SK-84", name: "Jim O'Riley" },
        { n: "SK-85", name: "John Bruce" },
        { n: "SK-86", name: "John DiBiase" },
        { n: "SK-87", name: "John Pleak" },
        { n: "SK-88", name: "John Still" },
        { n: "SK-89", name: "Jon McKenzie" },
        { n: "SK-90", name: "Jonarton" },
        { n: "SK-91", name: "Jordan Maison" },
        { n: "SK-92", name: "Jose Ruiz" },
        { n: "SK-93", name: "Jose Ventura" },
        { n: "SK-94", name: "Joshua Bommer" },
        { n: "SK-95", name: "Jude Gallager" },
        { n: "SK-96", name: "Kaela Croft" },
        { n: "SK-97", name: "Kallan Archer" },
        { n: "SK-98", name: "Kevin Cleveland" },
        { n: "SK-99", name: "Kevin Graham" },
        { n: "SK-100", name: "Kevin Liell" },
        { n: "SK-101", name: "Kevin P. West" },
        { n: "SK-102", name: "Kurt Ruskin" },
        { n: "SK-103", name: "Laura Atkinson" },
        { n: "SK-104", name: "Laura Martin" },
        { n: "SK-105", name: "Lee Hunt" },
        { n: "SK-106", name: "Lee Dumarquez" },
        { n: "SK-107", name: "Lee Lightfoot" },
        { n: "SK-108", name: "Logan Monette" },
        { n: "SK-109", name: "Louise Draper" },
        { n: "SK-110", name: "Madison Emerick" },
        { n: "SK-111", name: "Maggie Ransom" },
        { n: "SK-112", name: "Marcia Dye" },
        { n: "SK-113", name: "Mark Finneral" },
        { n: "SK-114", name: "Mark Mangum" },
        { n: "SK-115", name: "Mark Stroud" },
        { n: "SK-116", name: "Marlo Agunos" },
        { n: "SK-117", name: "Marsha Parkins" },
        { n: "SK-118", name: "Matt Kilness" },
        { n: "SK-119", name: "Matt Langford" },
        { n: "SK-120", name: "Matt Maldonado" },
        { n: "SK-121", name: "Matt Stewart" },
        { n: "SK-122", name: "Matthew Hirons" },
        { n: "SK-123", name: "Matthew Lopez" },
        { n: "SK-124", name: "Michael Mastermaker" },
        { n: "SK-125", name: "Michael Mettlen" },
        { n: "SK-126", name: "Michelle Rayner" },
        { n: "SK-127", name: "Mike Barnard" },
        { n: "SK-128", name: "Mike Stephens" },
        { n: "SK-129", name: "Mohammad Jilani" },
        { n: "SK-130", name: "Nathan Kennett" },
        { n: "SK-131", name: "Neil Camera" },
        { n: "SK-132", name: "Nicholas Baltra" },
        { n: "SK-133", name: "Nicholas Dertinger" },
        { n: "SK-134", name: "Nick Allsopp" },
        { n: "SK-135", name: "Nick Justus" },
        { n: "SK-136", name: "Nolan Dykstra" },
        { n: "SK-137", name: "Omar Salinas" },
        { n: "SK-138", name: "Pablo Diaz" },
        { n: "SK-139", name: "Patricio Carrasco" },
        { n: "SK-140", name: "Phil Hassewer" },
        { n: "SK-141", name: "Phillip Trujillo" },
        { n: "SK-142", name: "Rebecca Sharp" },
        { n: "SK-143", name: "Rees Finlay" },
        { n: "SK-144", name: "Rey Paez" },
        { n: "SK-145", name: "Rich Hennemann" },
        { n: "SK-146", name: "Rich Molinelli" },
        { n: "SK-147", name: "Richard Serrao" },
        { n: "SK-148", name: "Rob Teranishi" },
        { n: "SK-149", name: "Robert Hendrickson" },
        { n: "SK-150", name: "Robert Stewart IV" },
        { n: "SK-151", name: "Rodney Roberts" },
        { n: "SK-152", name: "Ronnie Crowther" },
        { n: "SK-153", name: "Ryan Crosby" },
        { n: "SK-154", name: "Ryan Finley" },
        { n: "SK-155", name: "Ryan Moffett" },
        { n: "SK-156", name: "Ryan Olsen" },
        { n: "SK-157", name: "Ryan Santos" },
        { n: "SK-158", name: "Sammy Gomez" },
        { n: "SK-159", name: "Sebastian \"Sobot\" Cortez" },
        { n: "SK-160", name: "Shane Molina" },
        { n: "SK-161", name: "Shaow Siong" },
        { n: "SK-162", name: "Sheikh Islam" },
        { n: "SK-163", name: "Solly Mohamed" },
        { n: "SK-164", name: "Steve Alce" },
        { n: "SK-165", name: "Steve Fuchs" },
        { n: "SK-166", name: "Ted Dastick Jr." },
        { n: "SK-167", name: "Thomas Amici" },
        { n: "SK-168", name: "Tiffany Groves" },
        { n: "SK-169", name: "Tim Dowler" },
        { n: "SK-170", name: "Tim Proctor" },
        { n: "SK-171", name: "Tim Smith" },
        { n: "SK-172", name: "Tina Berardi" },
        { n: "SK-173", name: "Todd Rayner" },
        { n: "SK-174", name: "Travis Kinnison" },
        { n: "SK-175", name: "Trent Westbrook" },
        { n: "SK-176", name: "Victor Moreno" },
        { n: "SK-177", name: "Vincenzo \"Chenduz\" D'Ippolito" },
        { n: "SK-178", name: "Ward Silverman" },
        { n: "SK-179", name: "Wayne Tully" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array (or deliberately none), so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
